<template>
    <div class="flex flex-column">
        <div>{{ this.pageTitle || "" }}</div>

        <div v-if="!loading" class="custom-breadcrumbs">
            <template v-for="(crumb, i) in breadcrumbs">
                <span v-if="i !== breadcrumbs.length - 1" class="breadcrumb-link" @click="navigate(crumb)">
                    {{ crumb.text }}
                </span>

                <span v-else class="breadcrumb-current" >{{ crumb.text }}</span>

                <span v-if="i !== breadcrumbs.length - 1" class="custom-divider">/</span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pageTitle: { type: String, default: null },
        breadcrumbs: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },
    methods: {
        navigate(crumb) {
            if (crumb.to) {
                this.$router.push(crumb.to);
            }
        },
    },
};
</script>

<style scoped>
.custom-breadcrumbs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    font-size: 0.9rem;
}

.breadcrumb-link {
    cursor: pointer;
    color: #888;
}

.breadcrumb-current {
    color:#F41823;
}

.custom-divider {
    margin: 0 4px;
    color: #888;
    font-weight: bold;
}
</style>
